jQuery(document).ready(function($) {
	$('.top_carousel').slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        dots: true,
        arrows: false,
        appendDots: '.controller',
        appendArrows: '.controller',
        autoplay: false,
      });

      $(function(){
        var beforePos = 0;//スクロールの値の比較用の設定
    
        //スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
        function ScrollAnime() {
            var elemTop = 300;//#area-2の位置まできたら
          var scroll = $(window).scrollTop();
            //ヘッダーの出し入れをする
            if(scroll == beforePos) {
            //IE11対策で処理を入れない
            }else if(elemTop > scroll || 0 > scroll - beforePos){
            //ヘッダーが上から出現する
            $('.fixed_area').removeClass('UpMove'); //#headerにUpMoveというクラス名を除き
            $('.fixed_area').addClass('DownMove');//#headerにDownMoveのクラス名を追加
            }else {
            //ヘッダーが上に消える
            $('.fixed_area').removeClass('DownMove');//#headerにDownMoveというクラス名を除き
            $('.fixed_area').addClass('UpMove');//#headerにUpMoveのクラス名を追加
            }
            
            beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
        }
    
    
        // 画面をスクロールをしたら動かしたい場合の記述
        $(window).scroll(function () {
          ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
        });
    
        // ページが読み込まれたらすぐに動かしたい場合の記述
        $(window).on('load', function () {
          ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
        });
    
    
    
    
        //リンク先のidまでスムーススクロール
        //※ページ内リンクを行わない場合は不必要なので削除してください
            var headerH = $("#header").outerHeight(true);//headerの高さを取得    
            $('#g-navi li a').click(function () {
          var elmHash = $(this).attr('href'); 
          var pos = $(elmHash).offset().top-headerH;//header分の高さを引いた高さまでスクロール
          $('body,html').animate({scrollTop: pos}, 1000);
          return false;
        });
      });

      $(".search_open").click(function(){
        $(this).addClass("open");
        $(".search_bg").addClass("active");
        $("body").addClass("modal_open");
      });
      $(document).on('click touchend',function(e) {
        if(!$(e.target).closest('.search_open').length) {
         if(!$(e.target).closest('#searchform').length) {
           $("#searchform input ").val("");
           $(".search_open").removeClass("open");
           $(".search_bg").removeClass("active");
           if($("body").hasClass("modal_open")){
            $("body").removeClass("modal_open");
           }
         }
        }else{
         if($(e.target).closest('.clear').length) {
           $("#searchform input").val("");
           $(".search_open").removeClass("open");
           $(".search_bg").removeClass("active");
         }
        }
     });
     $(".search_area .clear").click(function(){
       $(".search_area input").val("");
     });

     $(function(){
      $(".humburger_menu").click(function(){
        $(this).toggleClass("open");
        $(".sp_navigation").toggleClass("open");
        $("body").toggleClass("menu_open");
      });
     });

     $(function(){
      $(".tags li").hover(function() {
        $(this).parents("a").parent().addClass("disable");
      },
      function() {
        $(this).parents("a").parent().removeClass("disable");
      });
    });
    $(function() {
      $('[data-tag]').on('click', function(e) {
          e.preventDefault();
          var url = $(this).data('tag');
          location.href = url;
      });
    });
});